export default __webpack_public_path__ + "static/Reading_the_Meter_Full_Color-32ba9418bf55c514c15f5a865c0f0483.png";